"use client";

import dynamic from "next/dynamic";
import SquareShimmer from "@/components/ui/shimmerUi/SquareShimmer";

/**
 * Client-only dynamic wrapper around `ClientAwardSwiperIndex`.
 *
 * Defers the Swiper + award-card chunk out of the initial JS bundle so the
 * 400–600 ms hydration burst on treatment routes shrinks. The shimmer matches
 * the carousel's resting height (one row of award cards).
 */
const ClientAwardSwiperIndex = dynamic(
  () => import("./ClientAwardSwiperIndex"),
  {
    ssr: false,
    loading: () => (
      <div className="h-[260px] md:h-[300px] w-full py-3">
        <SquareShimmer />
      </div>
    ),
  }
);

export default ClientAwardSwiperIndex;
